import { createFileRoute, redirect } from '@tanstack/react-router';

import { schema } from './performance/index.route';

export const Route = createFileRoute(
  '/_private/_route/_internal/people/$identityId/_candidate/recommendations/',
)({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      params: { identityId: params.identityId },
      replace: true,
      search,
      to: '/people/$identityId/performance',
    });
  },
  validateSearch: schema,
});
